// 기록 열쇠를 이 기기(브라우저 저장소 IndexedDB)에 둔다. 화면과 엔진 워커가 함께 쓴다.
// 열쇠는 '밖으로 꺼낼 수 없는' CryptoKey 그대로 저장한다 — 자바스크립트로도 원래 바이트를 읽을 수 없다.

const DB_NAME = 'apex-cloud';
const STORE = 'keys';

interface Stored { userId: string; key: CryptoKey }

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx<T>(mode: IDBTransactionMode, run: (s: IDBObjectStore) => IDBRequest): Promise<T> {
  const db = await open();
  try {
    return await new Promise<T>((resolve, reject) => {
      const req = run(db.transaction(STORE, mode).objectStore(STORE));
      req.onsuccess = () => resolve(req.result as T);
      req.onerror = () => reject(req.error);
    });
  } finally {
    db.close();
  }
}

export const saveKey = (userId: string, key: CryptoKey): Promise<unknown> => tx('readwrite', (s) => s.put({ userId, key } satisfies Stored, 'current'));

/** 이 사람의 열쇠 (다른 사람 것이 들어 있으면 null) */
export async function loadKey(userId: string): Promise<CryptoKey | null> {
  const v = await tx<Stored | undefined>('readonly', (s) => s.get('current'));
  return v && v.userId === userId ? v.key : null;
}

/** 이 기기에 열쇠를 둔 사람 (없으면 null) */
export async function keyOwner(): Promise<string | null> {
  const v = await tx<Stored | undefined>('readonly', (s) => s.get('current'));
  return v?.userId ?? null;
}

export const clearKey = (): Promise<unknown> => tx('readwrite', (s) => s.delete('current'));
